export default __webpack_public_path__ + "static/media/oil & gas.d8a6b1a3.jpg";